import Button from "components/button";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 2rem;
`;

export const StyledBlock = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;

export const StyledButton = styled(Button)`
  margin-top: -1.5rem;
`;

export const StyledLocaleSwitcher = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;

interface LocaleProps {
  $active: boolean;
}

export const StyledLocale = styled.div<LocaleProps>`
  cursor: pointer;
  margin-top: 0.4rem;
  ${(props) =>
    props.$active &&
    css`
      text-decoration: underline;
    `}
`;
